import React, { useEffect, useState } from 'react';
import API from '../../API';
import { Button, Form, FormControl, InputGroup, Pagination, Table } from 'react-bootstrap';
import { SearchIcon } from '../../components/Icons';
import Loader from '../../components/Loader';
import Avatar from '../../components/Avatar';
import { Link } from 'react-router-dom';
import { SINGLE_POST, USER_PROFILE } from '../../constants/routes';
import { deletePost } from '../../reducers/feed/feed.actions';
import { deletePostSuccessActionCreator } from '../../reducers/feed/feed.actionCreators';

const Reports = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [reports, setReports] = useState([]);
  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [status, setStatus] = useState('all');

  const fetchReports = paginate => {
    setIsLoading(true);
    let params = {};
    if (status && status !== 'all') {
      params.reportable_type = status;
    }
    API.get('reports', { page: paginate ? paginate : page, ...params })
      .then(resp => {
        setReports(resp.data);
        setPage(resp.meta.current_page);
        setLastPage(resp.meta.last_page);
        setIsLoading(false);
      })
      .catch(errors => {
        console.log('admin reports fetch error', errors);
        setIsLoading(false);
      });
  };
  const handleFilter = e => {
    setStatus(e.target.value);
    setPage(1);
  };
  useEffect(() => {
    fetchReports();
  }, [status]);

  const handleDelete = async (report, type) => {
    if (window.confirm('This action can not be undone. Are you sure you want to delete?')) {
      setIsLoading(true);
      const id = report.reported_object.id;
      if (type === 'post') {
        await API.delete(`/posts/${id}`).catch(err => {
          console.log('delete error', err);
        });
      }
      if (type === 'user') {
        await API.delete(`/user/${id}`).catch(err => {
          console.log('delete error', err);
        });
      }
      API.delete(`/report/${report.id}`)
        .then(resp => {
          fetchReports();
          return resp;
        })
        .catch(err => {
          throw err;
        });
    }
  };
  return (
    <div className="p-1">
      <div className="d-flex justify-content-between align-items-center">
        <h3 className="m-0">Reports</h3>

        <Form inline className="">
          <Form.Label className=" mr-2" htmlFor="inlineFormCustomSelectPref">
            Filter
          </Form.Label>
          <Form.Control as="select" value={status} onChange={handleFilter} className="" custom>
            <option value="all">All</option>
            <option value="post">Posts</option>
            <option value="user">Users</option>
          </Form.Control>
        </Form>
      </div>
      <hr />
      <Loader isLoadin={isLoading} height={36} size={28}>
        <Table striped bordered hover size="sm" responsive>
          <thead>
            <tr>
              <th width="50" className="text-center">
                ID
              </th>
              <th>Reporter</th>
              <th>Type</th>
              <th>Message</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {!!reports.length &&
              reports.map(row => (
                <tr key={row.id}>
                  <td className="text-center">{row.id}</td>
                  <td>
                    <div className="d-flex align-items-center cursor-pointer">
                      {row.reporter.email}:{row.reporter.name}{' '}
                      <span className="text-gray">{row.reporter.nickname ? '@' + row.reporter.nickname : ''}</span>
                    </div>
                  </td>
                  <td>{row.reported_type}</td>
                  <td>{row.body}</td>
                  <td className="d-flex">
                    <Link
                      className="d-flex align-items-center mr-2"
                      to={
                        row.reported_type === 'post'
                          ? SINGLE_POST.replace(':id', row.reported_object.id)
                          : row.reported_type === 'user' &&
                          USER_PROFILE.replace(':userId?', row.reported_object.id).replace(
                            ':name?',
                            !!row.reported_object.nickname ? row.reported_object.nickname : ''
                          )
                      }
                      target="_blank"
                    >
                      View
                    </Link>
                    <Button
                      size="sm"
                      className="mr-2 btn btn-danger"
                      onClick={() => handleDelete(row, row.reported_type)}
                    >
                      Delete {row.reported_type}
                    </Button>
                    <Button size="sm" className="mr-2 btn" onClick={() => handleDelete(row, 'report')}>
                      Delete Report
                    </Button>
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>
        {lastPage > 1 && (
          <Pagination className="d-flex justify-content-center">
            <Pagination.First disabled={page === 1}
              onClick={() => fetchReports(1)}
            />
            <Pagination.Prev disabled={page === 1}
              onClick={() => fetchReports(page - 1)}
            />
            <Pagination.Item active>{page}</Pagination.Item>
            <Pagination.Next disabled={page === lastPage}
              onClick={() => fetchReports(page + 1)}
            />
            <Pagination.Last disabled={page === lastPage}
              onClick={() => fetchReports(lastPage)}
            />
          </Pagination>
        )}
      </Loader>
    </div>
  );
};

export default Reports;
